// extracted by mini-css-extract-plugin
module.exports = {"container":"i_EU","loading-icon":"i_EV","text":"i_EW"};